// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM6 13.0039V11H8.00391V13.0039L6 13.0039ZM11 13.0039V11H13.0039V13.0039H11ZM18.0039 13.0039L16 13.0039V11H18.0039L18.0039 13.0039Z"}}]};

const PendingFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'pending-filled',
    ref,
    icon: element,
  },
));

PendingFilledIcon.displayName = 'PendingFilledIcon';

export default PendingFilledIcon;
